import MarketReportsService from '@/services/MarketReportsService';

export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      activeConfiguration: null,
    }
  },
  methods: {
    newWaveDetail(event) {
      let sortOrder = this.activeConfiguration.waveDetails.length > 0 
        ? (_.maxBy(this.activeConfiguration.waveDetails, 'sortOrder').sortOrder)
        : 0;
      var sortOrderNumber = parseInt(sortOrder) + 1;
      this.activeConfiguration.waveDetails.push({
        header: 'Header' + sortOrderNumber,
        text: '',
        sortOrder: sortOrderNumber
      });
    },
    getStateDetailHeader(waveDetail) {
      return waveDetail.header.length > 0 
        && _.filter(this.activeConfiguration.waveDetails, 
          x => x.header === waveDetail.header).length <= 1;
    },
    getStateDetailSortOrder(waveDetail) {
      return /^[0-9]+$/.test(waveDetail.sortOrder) 
        && waveDetail.sortOrder !== ''
        && parseInt(waveDetail.sortOrder) > 0
        && _.filter(this.activeConfiguration.waveDetails, 
            x => parseInt(x.sortOrder) === parseInt(waveDetail.sortOrder)).length <= 1;
    },
    deleteWaveDetail(index) {
      let deleted = this.activeConfiguration.waveDetails.splice(index, 1);
      if (deleted[0].id !== null && deleted[0].id !== undefined) {
        this.activeConfiguration.waveDetailsDeleted.push(deleted[0].id);
      }
    },
    saveWaveDetails(event) {
      this.isBusy = true;
      MarketReportsService.updateMarketReportsConfigurationWaveDetails(this.activeConfiguration)
        .then((res) => {
          this.loadFilters(true);
        })
        .catch((error) => {
          console.error(error)
          this.isBusy = false;
        });
      this.$refs.editWaveDetailsModal.hide();
    },

    getConfigurationsFixed(configurations) {
      for (const configuration of configurations) {
        configuration.waveDetailsDeleted = [];
      }
      return configurations;
    }
  }
};
